import foot from './foots.vue';
import Vue from 'vue'
const Foot = {
    install: function() {
        Vue.component('Foot', foot)
    }
}
export default Foot;